import { type Option } from 'payload'

export enum UserRole {
  Admin = 'admin',
  Writer = 'writer',
  Editor = 'editor',
  User = 'user',
  Member = 'member',
  Partner = 'partner',
  Sales = 'sales',
  Author = 'author',
  Customer = 'customer',
}

const userRoleLabels = {
  [UserRole.Admin]: 'admin',
  [UserRole.Writer]: 'writer',
  [UserRole.Editor]: 'editor',
  [UserRole.User]: 'user',
  [UserRole.Member]: 'member',
  [UserRole.Partner]: 'partner',
  [UserRole.Sales]: 'sales',
  [UserRole.Author]: 'author',
  [UserRole.Customer]: 'customer',
} as const

export const userRoleOptions: Option[] = [
  {
    label: userRoleLabels[UserRole.Admin],
    value: UserRole.Admin,
  },
  {
    label: userRoleLabels[UserRole.Writer],
    value: UserRole.Writer,
  },
  {
    label: userRoleLabels[UserRole.Editor],
    value: UserRole.Editor,
  },
  {
    label: userRoleLabels[UserRole.User],
    value: UserRole.User,
  },
  {
    label: userRoleLabels[UserRole.Member],
    value: UserRole.Member,
  },
  {
    label: userRoleLabels[UserRole.Partner],
    value: UserRole.Partner,
  },
  {
    label: userRoleLabels[UserRole.Sales],
    value: UserRole.Sales,
  },
  {
    label: userRoleLabels[UserRole.Author],
    value: UserRole.Author,
  },
  {
    label: userRoleLabels[UserRole.Customer],
    value: UserRole.Customer,
  },
] as const satisfies Option[]

export enum AuthProvider {
  Google = 'google',
  Email = 'email',
  MagicLink = 'magic-link',
}

const authProviderLabels = {
  [AuthProvider.Google]: 'Google',
  [AuthProvider.Email]: 'Email',
  [AuthProvider.MagicLink]: 'Magic Link',
} as const

export const authProviderOptions: Option[] = [
  {
    label: authProviderLabels[AuthProvider.Google],
    value: AuthProvider.Google,
  },
  {
    label: authProviderLabels[AuthProvider.Email],
    value: AuthProvider.Email,
  },
  {
    label: authProviderLabels[AuthProvider.MagicLink],
    value: AuthProvider.MagicLink,
  },
] as const satisfies Option[]
